import React from 'react';
import { Route } from 'react-router-dom';
import Profile from '../components/Profile';

export default [
    <Route key='profile' exact path='/profile' component={Profile} />,
];